<script>
import options from './HoldetsRoundCounterOverlay.options'
export default options
</script>

<template>
  <template v-if="isSubmitting">
    <div class="kb-spinner-overlay">
      <div class="kb-spinner-overlay__spinner"></div>
    </div>
  </template>

  <article class="kb-holdets-round-counter-overlay">
    <section class="kb-holdets-round-counter-overlay__hero">
      <h2 class="kb-holdets-round-counter-overlay__hero__title">
        {{ getLabel('title') }}
      </h2>

      <div v-if="ruter.length" class="kb-holdets-round-counter-overlay__hero__global-counters">
        <h3 class="kb-holdets-round-counter-overlay__hero__global-counters__label">
          {{ getLabel('globalRoundCounterLabel') }}
        </h3>
        <div class="kb-holdets-round-counter-overlay__hero__global-counters__wrapper">
          <template v-for="(rute, index) in ruter" :key="index">
            <StafetRoundCounter :rute="rute" :maxRegistrationCount="maxRegistrationCount" />
          </template>
        </div>
      </div>
      <div v-else>
        {{ getLabel('no-routes-text') }}
      </div>
    </section>
    <div class="kb-holdets-round-counter-overlay__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z"
        />
      </svg>
    </div>

    <div v-if="ruter.length" class="kb-holdets-round-counter-overlay__participants">
      <StafetRoundCounterAccordion
        :participantData="deltagere"
        :maxRegistrationCount="maxRegistrationCount"
      />
    </div>
  </article>
</template>
